import isNil from 'lodash/isNil';

export function getBalance(values) {
    let balance = values.reservationSchedule.confirmation_amount;
    let balanceClass = '';
    let isRemaining = false;
    if (values.reservationStatus.state !== 'NOTPAID') {
        if (values.reservationStatus.is_overpaid) {
            balance = '(' + values.reservationSchedule.current_balance + ')';
            balanceClass = 'balance-value-negative';
        } else {
            balance = values.reservationSchedule.current_balance;
            isRemaining = true;
        }
    }
    return { balance, balanceClass, isRemaining };
}

export function getBalanceLabel(values) {
    let label = 'Confirmation Amount';

    if (values.reservationStatus.state !== 'NOTPAID') {
        if (values.reservationStatus.is_overpaid) {
            label = 'Refund Amount';
        } else {
            label = 'Remaining Balance';
        }
    }
    return label;
}

export function getOtherDepositsPaid(values) {
    let text = '';
    if (!values.reservationSchedule.other_deposits_paid) {
        if (!isNil(values.reservationSchedule.balance_date_for_display)) {
            text = `due by ${values.reservationSchedule.balance_date_for_display}`;
        } else {
            text = 'due immediately';
        }
    }
    return text;
}

export function getShowOtherDeposits(values) {
    let value = values.confirmationBreakdown.show_other_deposits;
    return value && values.confirmationBreakdown.deposit_payment_sum;
}

export function getReservationStatusIcon(reservationStatus) {
    let icon = 'reservation-status-icon-';
    if (reservationStatus.state === 'PAID') {
        if (reservationStatus.is_overpaid) {
            return icon + 'refund-owed';
        } else {
            return icon + 'paid';
        }
    } else if (reservationStatus.state === 'PAIDDEPOSIT') {
        return icon + 'confirmed';
    } else if (reservationStatus.state === 'NOTPAID') {
        return icon + 'unconfirmed';
    } else if (reservationStatus.state === 'CANCELLED') {
        return icon + 'cancelled';
    }
}
export function getReservationStatusColor(reservationStatus) {
    let color = 'reservation-status-color-';
    if (reservationStatus.state === 'PAID') {
        if (reservationStatus.is_overpaid) {
            return color + 'refund-owed';
        } else {
            return color + 'paid';
        }
    } else if (reservationStatus.state === 'PAIDDEPOSIT') {
        return color + 'confirmed';
    } else if (reservationStatus.state === 'NOTPAID') {
        return color + 'unconfirmed';
    } else if (reservationStatus.state === 'CANCELLED') {
        return color + 'cancelled';
    }
}
